import React, { useEffect, useState, useRef } from 'react';
import { Table, Form, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { IoAdd } from 'react-icons/io5';
import { firestore } from '../../firebase';

export default function ProductsTable() {
    const [products, setProducts] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState(firestore.collection('productos').orderBy('descripcion').limit(20));
    const limit = useRef(20);
    const productsLength = useRef(0);
    const [supplier, setSupplier] = useState("");
    const [category, setCategory] = useState("");

    function getProducts() {
        setLoading(true);
        query.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                items.push({
                    id: doc.id,
                    codigo: data.codigo,
                    descripcion: data.descripcion,
                    proveedor: data.proveedor,
                    categoria: data.categoria,
                    cantidad: data.cantidad.actual,
                    precio: data.precio
                })
            })
            productsLength.current = items.length;
            setProducts(items);
            setLoading(false);
        })
    }

    function getSuppliers() {
        setLoading(true);
        
        const suppliersQuery = firestore.collection('proveedores').orderBy('nombre');
        suppliersQuery.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                items.push(doc.data());
            })
            setSuppliers(items);
            setLoading(false);
        })
    }

    function createQuery(e) {
        e.preventDefault();
        let newQuery = firestore.collection('productos');

        if (supplier) {
            newQuery = newQuery.where('proveedor', '==', supplier);
        }

        if (category) {
            newQuery = newQuery.where('categoria', '==', category);
        }

        if (search) {
            const searchArray = search.toLowerCase().split(' ')
            newQuery = newQuery.where('keywords', 'array-contains-any', searchArray)
        }

        setQuery(newQuery.orderBy('descripcion').limit(limit.current));
    }

    function handleSupplierChange(e) {
        e.preventDefault();
        setSupplier(e.target.value); 
    }

    function handleCategoryChange(e) {
        e.preventDefault();
        setCategory(e.target.value); 
    }

    function handleScroll(e) {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = window.innerHeight + window.pageYOffset;
        
        if (Math.ceil(windowBottom) >= docHeight && productsLength.current === limit.current) {
            limit.current = limit.current+20;
            createQuery(e);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getProducts();
        getSuppliers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])
    return (
        <>
            <Form onSubmit={createQuery}>
                <Row className="m-2">
                    <Col className="my-1" xs={12}>
                        <Form.Group controlId="searchBar">
                            <Form.Control 
                            type="text" 
                            placeholder="Buscar por código, descripción, proveedor, categoría..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="m-2" xs="auto">
                    <Form.Group className="my-1"controlId="formSearchSuppliers">
                        <Form.Control 
                        as="select" custom
                        onChange={handleSupplierChange}
                        >
                            <option value="">Seleccione un proveedor</option>
                            {suppliers && 
                            suppliers.map(sup => {
                                return(
                                    <option key={sup.nombre} value={sup.nombre}>{sup.nombre}</option>
                                )
                            })}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="my-1"controlId="formSearchCategory">
                        <Form.Control
                        as="select" custom
                        onChange={handleCategoryChange}
                        >
                            <option value="">Seleccione una categoría</option>
                            <option value="Equipo">Equipo</option>
                            <option value="Consumible">Consumible</option>
                            <option value="Repuesto">Repuesto</option>
                            <option value="Otro">Otro</option>
                        </Form.Control>
                    </Form.Group>
                    <Col className="my-1" xs={12} sm={4}>
                        <Button type="submit">Buscar</Button>
                        <Button className="mx-1 py-0 px-1" href="/products/create" style={{fontSize: "1.55rem"}}><IoAdd/></Button>
                    </Col>
                </Row>
            </Form>
            <Table responsive striped bordered className='m-auto'>
                <thead>
                    <tr>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Proveedor</th>
                        <th>Categoría</th>
                        <th>Cantidad</th>
                        <th>Precio</th>
                    </tr>
                </thead>
                <tbody>
                    {products && 
                    products.map(product => {
                        return (
                            <tr key={product.id}>
                                <td>  
                                    <Link to={`/products/view_${product.id}`}>
                                        {product.codigo}
                                    </Link>
                                </td>
                                <td>{product.descripcion}</td>
                                <td>{product.proveedor}</td>
                                <td>{product.categoria}</td>
                                <td>{product.cantidad}</td>
                                <td>
                                    {new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: product.precio.divisa
                                    }).format(product.precio.cantidad)}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            {loading && <h3 className="text-muted m-3">Cargando...</h3>}
        </>
    )
}